// Minimal CSV parser for the employer-admin template (email, first_name,
// last_name, optional phone, company_code, optional job_title — README
// §4.2/ICIB-08g) — no quoted-comma handling
// needed for a file this simple. Returns an array of row objects keyed by
// header, so an optional column like job_title just flows through.
export function parseCsv(text) {
  const lines = text.split(/\r?\n/).map((l) => l.trim()).filter(Boolean);
  if (!lines.length) return [];
  const headers = lines[0].split(',').map((h) => h.trim());
  return lines.slice(1).map((line) => {
    const cells = line.split(',').map((c) => c.trim());
    const row = {};
    headers.forEach((h, i) => { row[h] = cells[i] ?? ''; });
    return row;
  });
}

function csvCell(v) {
  const s = v == null ? '' : String(v);
  return /[",\r\n]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
}

// Builds a CSV string from a header row plus data rows (arrays of values,
// same order as `headers`) — the inverse of parseCsv, for templates
// generated client-side rather than downloaded from the backend.
export function buildCsv(headers, rows = []) {
  const lines = [headers.map(csvCell).join(',')];
  for (const row of rows) lines.push(headers.map((h, i) => csvCell(row[i])).join(','));
  return lines.join('\r\n') + '\r\n';
}

// Triggers a browser download of a CSV string — same client-side pattern
// as icibDownload in IcibAdminContext, but for content built locally
// rather than fetched from the backend.
export function downloadCsv(filename, headers, rows) {
  const blob = new Blob([buildCsv(headers, rows)], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}
